import { ProductsApi, useAPIQuery } from "melco-shared-logic";

export const useProductVersionsDropDownData = (
  selectedProductValue: string
) => {
  return useAPIQuery(
    ProductsApi,
    ["productVersionsDropDownData"],
    async (api) => {
      //const api = new ProductsApi(baseApiConfig({ token }));

      if (selectedProductValue) {
        const response = await api.productsGetVersionList({
          productCode: selectedProductValue,
        });

        return response;
      }
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );
};
